import {
  PlayerSortKeys,
  PlayerInfoKeys,
  allStarPositionNameToCodeMap,
} from '../../Constant/player'
import { PlayerDataGQL, PlayersOnTeam, PositionNames } from '../../Api'
import type { FilteredResult } from '../../Constant/statsProcess'
import { Accolade } from '../../Api/Teams/team.types'
import { CURRENT_YEAR } from '../../Config/League/league.config'
import { extractStatFromObject } from './playerStatHelpers'

/**
 * Returns stats for player depending at his position and stat type
 */
export const getFavPlayerStats = (player: PlayerDataGQL): FilteredResult[] => {
  const pos = player.currentTeam.position
  if (!pos) return []
  return extractStatFromObject(pos, 'fav', player.stats || {})
}

export const sortPlayers = (
  players: PlayerDataGQL[],
  sortBy: PlayerSortKeys,
  ascDesc: -1 | 1,
  isChampSeries: boolean = false
): PlayerDataGQL[] => {
  return players.sort((a, b) => {
    const A =
      isChampSeries && a?.champSeries?.stats
        ? a?.champSeries?.stats[sortBy]
        : a.stats[sortBy]
    const B =
      isChampSeries && b?.champSeries?.stats
        ? b?.champSeries?.stats[sortBy]
        : b.stats[sortBy]
    const numA = typeof B === 'number' ? B : 0
    const numB = typeof A === 'number' ? A : 0
    if (ascDesc < 0) {
      return numA - numB
    } else {
      return numB - numA
    }
  })
}

export const sortPlayersByPosition = (
  players: PlayerDataGQL[],
  sortBy: PlayerInfoKeys,
  ascDesc: -1 | 1
): PlayerDataGQL[] => {
  return players.sort((a, b) => {
    const A = a[sortBy]
    const B = b[sortBy]
    if (sortBy === 'lastName') {
      if (ascDesc < 0) {
        return b.lastName.localeCompare(a.lastName)
      } else {
        return a.lastName.localeCompare(b.lastName)
      }
    }
    const numA = typeof B === 'number' ? B : 0
    const numB = typeof A === 'number' ? A : 0
    if (ascDesc < 0) {
      return numA - numB
    } else {
      return numB - numA
    }
  })
}

export const mapInjuryStatus = (status: string) => {
  if (!status) return ''
  const lowerCase = status.toLowerCase()
  switch (lowerCase) {
    case 'o':
      return 'Out'
    case 'q':
      return 'Questionable'
    case 'ir':
      return 'Injured Reserve'
    case 'na':
      return 'Unavailable to travel'
    case 'utt':
      return 'Unavailable to travel'
    default:
      return ''
  }
}

export const getAllStarPositionCode = (positionName?: PositionNames): string => {
  if (!positionName) return ''
  const pos = positionName.toLowerCase()
  const code = Object.keys(allStarPositionNameToCodeMap).find(
    (key) => key.toLowerCase() === pos
  )
  if (code) return allStarPositionNameToCodeMap[code]
  return ''
}

export const getAccoladeCount = (accolade: string, player: PlayerDataGQL) => {
  if (player.accolades && player.accolades.length > 0) {
    let accoladeObj = player.accolades.find((a) => a.awardName === accolade)
    if (accoladeObj) {
      return accoladeObj.years.length
    } else {
      return 0
    }
  }
  return 0
}

export const returnAccoladeCount = (accolade: Accolade) => {
  return accolade.years.length || 0
}

/**
 * Returns player name formatted as "F. Last"
 */
export const formatPlayerName = (first?: string, last?: string) => {
  if (!first) return last || ''
  let firstInitial = first.charAt(0)
  return `${firstInitial}. ${last}`
}

/**
 * Returns player's years in the league
 */
export const getPlayerExperience = (player: PlayersOnTeam | PlayerDataGQL) => {
  return CURRENT_YEAR - player.expFromYear + 1
}
